import { Injectable } from '@angular/core';
import { Headers, Http } from '@angular/http';
import { environment } from '../../../../../../environments/environment';
import { Observable } from 'rxjs/Observable';

@Injectable()
// tslint:disable-next-line:class-name
export class StatisticsDistributedService {
  headers: Headers;
  url = environment.qrcode_url;
  url_avs = environment.api_evs;

  constructor(
    private http: Http
  ) {
    const token = localStorage.getItem('Access-Token');
    const lang = localStorage.getItem('lang');
    this.headers = new Headers({
      "Accept-Language": localStorage.getItem("lang") || "vi",
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
      'accept-language': `${lang}`
    });
  }

  getInvetoryProduct(query?: any): Observable<any> {
    return this.http.get(`${this.url}/statistic/account/distribution/product`, { headers: this.headers, params: query }).map(res => {
      return res.json();
    });
  }

  getInvetoryStamp(query?: any): Observable<any> {
    return this.http.get(`${this.url}/statistic/distribution/account/batch`, { headers: this.headers, params: query }).map(res => {
      return res.json();
    });
  }

  getOverviewDistributed(): Observable<any> {
    return this.http.get(`${this.url}/statistic/dashboard/distribution/overview`, { headers: this.headers }).map(res => {
      return res.json();
    });
  }

  getDistributedAgency(query?: any): Observable<any> {
    return this.http.get(`${this.url}/statistic/dashboard/distribution/agencies`, { headers: this.headers, params: query }).map(res => {
      return res.json();
    });
  }

  getOverfollow(query?: any): Observable<any> {
    return this.http.get(`${this.url}/statistic/dashboard/distribution/location/overflow`, {
      headers: this.headers,
      params: query
    }).map(res => {
      return res.json();
    });
  }

  // tuanba: 26/08/2022: Cấu hình tồn kho
  getListAgencyProduct(query?: any, id?: string) {
    return this.http.get(`${this.url}/statistic/distribution/agencies/${id}/product`, { headers: this.headers, params: query }).map(res => {
      return res.json();
    });
  }

  getListAgencyBatch(query?: any, id?: string) {
    return this.http.get(`${this.url}/statistic/distribution/agencies/${id}/batch`, { headers: this.headers, params: query }).map(res => {
      return res.json();
    });
  }

  /* New service for export file report distribute */
  exportReport(body) {
    return this.http
      .post(
        `${this.url_avs}/qr-core-aps/export`,
        body,
        {
          headers: this.headers,

        }
      )
      .map((res) => {
        console.info(res.json());
        return res.json();
      })
      .catch((error: any) => {
        throw error.json();
      });
  }

}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/evs/statistics-distributed/services/statistics-distributed.service.ts